import { render, staticRenderFns } from "./CommandsTable.vue?vue&type=template&id=348505e0&scoped=true"
import script from "./CommandsTable.vue?vue&type=script&lang=js"
export * from "./CommandsTable.vue?vue&type=script&lang=js"
import style0 from "./CommandsTable.vue?vue&type=style&index=0&id=348505e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348505e0",
  null
  
)

export default component.exports